<template>
  <div v-show="isShowLocaleButton" class="relative">
    <button
      ref="buttonRef"
      class="flex h-8 w-8 items-center justify-center rounded hover:bg-blue-400/10"
      :class="isShowMenu && 'bg-blue-400/10'"
      :title="$t('header.language')"
      @click="handleClick"
    >
      <IconLang class="h-5 w-5 text-blue-400" />
    </button>

    <div
      v-show="isShowMenu"
      ref="localeMenuRef"
      class="absolute right-0 top-11 z-10"
    >
      <LayoutHeaderLocaleMenu />
    </div>
  </div>
</template>

<script setup lang="ts">
  import { onClickOutside } from '@vueuse/core';

  const { locale } = useI18n();
  const { isShowLocaleButton } = useLanguage();

  const buttonRef = ref<HTMLElement | null>(null);
  const localeMenuRef = ref<HTMLElement | null>(null);
  const isShowMenu = ref<boolean>(false);

  const handleClick = (): void => {
    isShowMenu.value = !isShowMenu.value;
  };

  watch(locale, () => (isShowMenu.value = false));

  onClickOutside(
    localeMenuRef,
    () => {
      isShowMenu.value = false;
    },
    {
      ignore: [buttonRef],
    }
  );
</script>
